<template>
  <svg
    width="18.5263158px"
    height="16px"
    viewBox="0 0 18.5263158 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Dashboard-DNA"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="warning_24dp_FILL1_wght400_GRAD0_opsz24"
        fill="#D20000"
        fill-rule="nonzero"
      >
        <path
          id="Shape"
          d="M0,16 L9.26315789,0 L18.5263158,16 L0,16 Z M9.26315789,13.4736842 C9.50175439,13.4736842 9.70175439,13.3929825 9.86315789,13.2315789 C10.0245614,13.0701754 10.1052632,12.8701754 10.1052632,12.6315789 C10.1052632,12.3929825 10.0245614,12.1929825 9.86315789,12.0315789 C9.70175439,11.8701754 9.50175439,11.7894737 9.26315789,11.7894737 C9.0245614,11.7894737 8.8245614,11.8701754 8.66315789,12.0315789 C8.50175439,12.1929825 8.42105263,12.3929825 8.42105263,12.6315789 C8.42105263,12.8701754 8.50175439,13.0701754 8.66315789,13.2315789 C8.8245614,13.3929825 9.0245614,13.4736842 9.26315789,13.4736842 Z M8.42105263,10.9473684 L10.1052632,10.9473684 L10.1052632,6.73684211 L8.42105263,6.73684211 L8.42105263,10.9473684 Z"
        ></path>
      </g>
    </g>
  </svg>
</template>
